import './App.css';
import { HashRouter } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Cookies from './common/Cookies';
import { API_URL } from './common/Constants';
import { setPlansFromApi } from './utils/planUtils';
import AppRoutes from './components/base/AppRoutes';
import MenuPanel from './components/base/MenuPanel';
import Login from './components/Login';
import { Routes, Route } from 'react-router-dom';
import axios from 'axios';
import ResetPassword from './components/account/ResetPassword';
import Signup from './components/account/Signup';
import SignupForm from './components/account/SignupForm';
import InviteSetup from './components/account/InviteSetup';
import Footer from './components/base/Footer';
import TinyFooter from './components/base/TinyFooter';
import { AlertProvider } from './contexts/AlertContext';
import { ResellerProvider } from './contexts/ResellerContext';
import ThemeWrapper from './components/base/ThemeWrapper';
import ChatbotFramePage from './pages/public/ChatbotFramePage';
import SocialLoginCallback from './utils/socialloginlinks';
import ResellerChatbotWidget from './components/common/ResellerChatbotWidget';


export default function App() {
  const [loggedIn, setLoggedIn] = useState(Cookies.getJwtToken() && Cookies.getJwtToken().length > 0 ? true : false);

  // Load plan limits from database (chattitude_admin.plans) when user is logged in
  useEffect(() => {
    if (!loggedIn) return;
    const token = Cookies.getJwtToken();
    if (!token) return;
    axios
      .get(`${API_URL}/account/plans`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => {
        if (res.data?.success && Array.isArray(res.data.plans)) {
          setPlansFromApi(res.data.plans);
        }
      })
      .catch(() => { /* ignore; planUtils will use fallbacks */ });
  }, [loggedIn]);

  // Get user info from cookies or context (customize as needed)
  const user = {
    firstName: Cookies.getCookies('firstName') || '',
    lastName: Cookies.getCookies('lastName') || '',
    email: Cookies.getCookies('email') || ''
  };

  return (
    <HashRouter>
      <ResellerProvider>
        <ResellerChatbotWidget />
        <ThemeWrapper>
          <AlertProvider>
            <div className="App">
              <Routes>
                <Route path="/public/chatbot-frame" element={<ChatbotFramePage />} />
                {/* All other routes, wrapped in login logic */}
                {loggedIn ? (
                  <Route path="*" element={
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                      <div style={{ flex: '1 0 auto' }}>
                        <MenuPanel children={<AppRoutes loggedIn={loggedIn} setLoggedIn={setLoggedIn} user={user} />} />
                      </div>
                      {/* <TinyFooter /> */}
                    </div>
                  } />
                ) : (
                  <>
                    <Route path="/invite" element={<InviteSetup />} />
                    <Route path="/Signup" element={<Signup />} />
                    <Route path="/signup/form" element={<SignupForm setLoggedIn={setLoggedIn} />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/social-login/:token" element={<SocialLoginCallback setLoggedIn={setLoggedIn} />} />
                    <Route path="*" element={
                      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                        <div style={{ flex: '1 0 auto' }}>
                          <Login setLoggedIn={setLoggedIn} />
                        </div>
                        <Footer />
                      </div>
                    } />
                  </>
                )}
              </Routes>
            </div>
          </AlertProvider>
        </ThemeWrapper>
      </ResellerProvider>
    </HashRouter>
  );
}

// AuthLocationLogger removed (debug only)
